<template>
  <vxe-modal v-model="visible" :title="$t('business.label.address')" type="confirm" width="90%" @cancel="cancel" @confirm="confirm">
    <vxe-card>
      <template #title>
        <vxe-input v-model="customer.no" clearable placeholder="business.label.customerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="customer.name" clearable placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.company" clearable placeholder="business.label.company" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.contactor" clearable placeholder="business.label.contactMan" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.phone" clearable placeholder="business.label.phone" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.email" clearable placeholder="business.label.email" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="contactInfo.idType" :options="idTypes" clearable placeholder="business.label.idType" @change="refresh"/>
        <vxe-input v-model="contactInfo.idNumber" clearable placeholder="business.label.idNumber" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.country" clearable placeholder="business.label.country" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.province" clearable placeholder="business.label.province" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.city" clearable placeholder="business.label.city" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.district" clearable placeholder="business.label.district" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.town" clearable placeholder="business.label.town" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.village" clearable placeholder="business.label.village" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.street" clearable placeholder="business.label.street" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.postalCode" clearable placeholder="business.label.postalCode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.detailAddress" clearable placeholder="business.label.detailAddress" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading" :min-height="500" @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="direction.name" title="business.label.direction" width="80"/>
        <vxe-column field="contactInfo.company" title="business.label.company" width="80"/>
        <vxe-column field="contactInfo.contactor" title="business.label.contactor" width="80"/>
        <vxe-column field="contactInfo.phone" title="business.label.phone" width="80"/>
        <vxe-column field="contactInfo.email" title="business.label.email" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:idTypes}" field="contactInfo.idType" title="business.label.idType" width="80"/>
        <vxe-column field="contactInfo.idNumber" title="business.label.idNumber" width="80"/>
        <vxe-column field="addressInfo.country" title="business.label.country" width="80"/>
        <vxe-column field="addressInfo.province" title="business.label.province" width="80"/>
        <vxe-column field="addressInfo.city" title="business.label.city" width="80"/>
        <vxe-column field="addressInfo.district" title="business.label.district" width="80"/>
        <vxe-column field="addressInfo.town" title="business.label.town" width="80"/>
        <vxe-column field="addressInfo.village" title="business.label.village" width="80"/>
        <vxe-column field="addressInfo.street" title="business.label.street" width="80"/>
        <vxe-column field="addressInfo.postalCode" title="business.label.postalCode" width="80"/>
        <vxe-column field="addressInfo.detailAddress" title="business.label.detailAddress"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="addressInfo.defaults" title="business.label.defaults" width="60"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import { findAll } from '@/api/Api'
import { Party } from '@/api/dto/common/Party'
import { ContactInfo } from '@/api/dto/valueobject/ContactInfo'
import { AddressInfo } from '@/api/dto/valueobject/AddressInfo'

export default {
  name: 'AddressModal',
  data() {
    return {
      visible: false,
      loading: false,
      list: [],
      customer: new Party(),
      contactInfo: new ContactInfo(),
      addressInfo: new AddressInfo(),
      idTypes: [
        { label: '身份证', value: '1' },
        { label: '军官证', value: '2' },
        { label: '护照', value: '3' },
        { label: '其他', value: '4' }
      ],
      page: 1,
      size: 15,
      contentSize: 0,
      record: undefined
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    init(args) {
      this.list = []
      this.page = 1
      if (args) {
        this.customer.id = args['customer.id']
        this.customer.no = args['customer.no']
        this.customer.name = args['customer.name']
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      setTimeout(() => {
        this.fetch()
      }, 300)
    },
    fetch() {
      this.loading = true
      findAll('addressFactory', { 'customer.id': this.customer.id, 'customer.no': this.customer.no, 'customer.name': this.customer.name, contactInfo: this.contactInfo, addressInfo: this.addressInfo }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.customer = new Party()
      this.contactInfo = new ContactInfo()
      this.addressInfo = new AddressInfo()
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getCurrentRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>
